import React, { MouseEvent, useCallback, useEffect } from "react";
import Tabs from "src/components/Tabs/Tabs";
import "./App.css";
import Scene from "src/components/Scene/Scene";
import StartLoader from "src/components/StartLoader/StartLoader";
import { useWindowResize } from "src/hooks/useWindowResize";
import UiButtons from "src/components/UiButtons/UiButtons";
import TotalPrice from "src/components/TotalPrice/TotalPrice";
import SaveOfferForm from "src/components/SaveOfferForm/SaveOfferForm";
import ResultPopup from "src/components/ResultPopup/ResultPopup";
import LeftBar from "src/components/LeftBar/LeftBar";
import Loader from "src/components/LoaderPopup/Loader";
import { useLoader } from "src/contexts/LoaderContext";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import LegendBox from "./components/LegendBox/LegendBox";

const App: React.FC = () => {
  const windowWidth = useWindowResize();
  const {
    isStartLoaderVisible,
    setIsStartLoaderVisible,
    setIsSceneLoaderVisible,
    setIsWhiteSceneLoaderVisible,
  } = useLoader();
  const { configurator, isLoaded, setIsLoaded } = useConfiguration();

  const completeHandler = useCallback(() => {
    setIsSceneLoaderVisible(false);

    if (!isLoaded && configurator.isLoaded()) {
      setIsStartLoaderVisible(false);
      setIsWhiteSceneLoaderVisible(false);
      setIsLoaded(true);

      return true;
    }
  }, [
    configurator,
    isLoaded,
    setIsLoaded,
    setIsSceneLoaderVisible,
    setIsStartLoaderVisible,
    setIsWhiteSceneLoaderVisible,
  ]);

  useEffect(() => {
    setIsWhiteSceneLoaderVisible(true);
    setIsStartLoaderVisible(true);
  }, [setIsStartLoaderVisible, setIsWhiteSceneLoaderVisible]);

  useEffect(() => {
    const startHandler = () => {
      if (!isStartLoaderVisible) setIsSceneLoaderVisible(true);
    };

    configurator.getLoader().on("start", startHandler);

    return () => {
      configurator.getLoader().off("start", startHandler);
    };
  }, [configurator, isStartLoaderVisible, setIsSceneLoaderVisible]);

  useEffect(() => {
    configurator.getLoader().on("complete", completeHandler);

    return () => {
      configurator.getLoader().off("complete", completeHandler);
      configurator.resetCamera();
    };
  }, [
    setIsStartLoaderVisible,
    setIsSceneLoaderVisible,
    configurator,
    completeHandler,
  ]);

  useEffect(() => {
    const container = document.getElementById("configurator-container");
    if (!container) return;

    const onContainerClick = () => {
      container.scrollIntoView({
        behavior: "smooth",
      });
    };

    container.addEventListener("click", onContainerClick);
    return () => {
      container.removeEventListener("click", onContainerClick);
    };
  }, []);

  return (
    <>
      <StartLoader />
      <div className="configurator-container-hover">
        <div className={`configurator-ui-wrapper`}>
          <Scene />

          {/* {windowWidth > 768 && ( */}
          {/* <> */}
          <LeftBar />
          {/* </> */}
          {/* )} */}
          <div id="configurator-ui">
            <Tabs />
            <TotalPrice />
            <UiButtons />
          </div>
        </div>
        <Loader />
        <SaveOfferForm />
        <ResultPopup />
      </div>
    </>
  );
};

export default App;
